import db, { createRef, Timestamp } from "src/db";
import { converter2 } from "src/db/converter";
import * as Log from "src/util/SDayslogger";
import type Reconcile from "../types/Reconcile";

export interface ConversationAnalyticsQuery {
  clientId: string;
  start: Date;
  end: Date;
  phoneNumbers: string[];
}

export const getConversationAnalytics = async ({
  clientId,
  start,
  end,
  phoneNumbers,
}: ConversationAnalyticsQuery): Promise<Reconcile[]> => {
  if (!clientId || !start || !end || phoneNumbers.length === 0) return [];

  const startFormatted = Timestamp.fromDate(start);
  const endFormatted = Timestamp.fromDate(end);
  Log.info(
    `Fetching dashboard analytics for client ${clientId} from ${startFormatted} to ${endFormatted}`
  );

  try {
    const snapshot = await db
      .collection("reconciliations")
      .withConverter(converter2<Reconcile>())
      .where("client", "==", createRef("clients", clientId))
      .where("mutationStartDate", ">=", startFormatted)
      .where("mutationStartDate", "<=", endFormatted)
      .where("granularity", "==", "HALF_HOUR")
      .where("wabaPhoneNumber", "in", phoneNumbers)
      .get();

    const analytics = snapshot.docs.map((doc) => ({
      ...doc.data(),
      id: doc.id,
    }));
    Log.info("getConversationAnalytics:", analytics.length);
    return analytics;
  } catch (error) {
    Log.error("Failed to fetch dashboard analytics", error);
    return [];
  }
};
